export const posthogRewriteBasePath = "/api/posthog"

export const posthogRewrites = [
  {
    source: posthogRewriteBasePath + "/static/:path*",
    destination: "https://eu-assets.i.posthog.com/static/:path*",
  },
  {
    source: posthogRewriteBasePath + "/:path*",
    destination: "https://eu.i.posthog.com/:path*",
  },
  {
    source: posthogRewriteBasePath + "/decide",
    destination: "https://eu.i.posthog.com/decide",
  },
]
